import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EcdStates } from '../../root/ecd-model';
import { getEcdEpiProps, setClergySettingsProps } from '../ducks/epi-api';
import { EcdRootPage } from '../models/ecd-page-models';
import { EcdClergySettingsProps } from '../models/epi-model';

export function useEpiClergySettingsLoaded() : boolean {
    return useSelector<EcdStates, boolean>(state => state.epiProps?.clergySettingsState?.clergySettingsLoaded);
}

export function useEpiClergySettings() : EcdClergySettingsProps {

    const ecdClergyPageContentId: string = (useSelector<EcdStates, any>(state => state.epiProps?.contentState?.epiContent) as EcdRootPage)?.clergySettingId;
    const language = useSelector<EcdStates, string>(state => state.globalization?.currentlanguage);
    const stateData = useSelector<EcdStates, EcdClergySettingsProps>(state => state.epiProps?.clergySettingsState?.clergySettings);
    const contentLoaded = useEpiClergySettingsLoaded();    

    const dispatch = useDispatch();

    useEffect(() => {
        if (!contentLoaded && ecdClergyPageContentId){
            dispatch(getEcdEpiProps(dispatch, ecdClergyPageContentId, {}, language, false, setClergySettingsProps));
        }
    }, [contentLoaded, ecdClergyPageContentId]);

    return stateData;
}